import React from 'react'

const Consultancy = () => {
    return (
        <div>
            Consultancy
        </div>
    )
}

export default Consultancy
